import React from "react";
import { Box, Flex, Heading } from "rebass";
import { Field, Form } from "formik";

import { FormControl } from "./FormControl";
import { FolderInput } from "./FolderInput";
import { ImportType } from "../types";
import { FIELD_FOLDER_ID } from "../formSettings";

const titleList = {
  [ImportType.dropbox]: "Dropbox",
  [ImportType.googleDrive]: "Google Drive",
  [ImportType.computerUpload]: "File System",
};

interface IProps {
  importType: Exclude<ImportType, ImportType.writtenText>;
}

export const FormLayout: React.FC<IProps> = ({ children, importType }) => (
  <Form style={{ height: "100%" }}>
    <Flex
      height="100%"
      flexDirection="column"
    >
      <Heading
        as="h4"
        m="35px 35px 25px"
        fontSize="26px"
        color="zodiac"
      >
        Import from {titleList[importType]}
      </Heading>

      <Field name={FIELD_FOLDER_ID} component={FolderInput} />

      <Box
        flex="1"
        px="18px"
        pb="18px"
        css="overflow: hidden;"
      >
        {children}
      </Box>

      <FormControl />
    </Flex>
  </Form>
);
